(() => {
  if (customElements.get('eudm-carismo-bundle')) return;
  class CarismoBundle extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-wheel-json]').textContent);
      this.button = this.querySelector('[data-add]');
      this.status = this.querySelector('.ecb-status');
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('change', event => {
        const row = event.target.closest('.ecb-row');
        if (row && event.target.type === 'checkbox' && event.target.checked && row.dataset.kind === 'Shift Paddles') {
          this.querySelectorAll('.ecb-row[data-kind="Shift Paddles"]').forEach(other => { if (other !== row) other.querySelector('input').checked = false; });
        }
        this.update();
      }, { signal });
      document.addEventListener('change', () => this.update(), { signal });
      this.button.addEventListener('click', () => this.addItems(), { signal });
      this.observer = new MutationObserver(() => this.update());
      const form = document.getElementById(this.dataset.form);
      if (form) this.observer.observe(form, { subtree: true, attributes: true, attributeFilter: ['value'] });
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    selection() {
      const form = document.getElementById(this.dataset.form);
      const id = Number(form?.querySelector('[name="id"]')?.value);
      const quantity = Math.max(1, Number(document.querySelector(`[name="quantity"][form="${this.dataset.form}"]`)?.value || form?.querySelector('[name="quantity"]')?.value || 1));
      const wheel = this.data.variants.find(variant => variant.id === id);
      const items = wheel ? [{ id, quantity }] : [];
      let total = (wheel?.price || 0) * quantity;
      this.querySelectorAll('.ecb-row').forEach(row => {
        const checkbox = row.querySelector('input');
        const option = row.querySelector('select').selectedOptions[0];
        if (!option || option.dataset.available !== 'true') { checkbox.checked = false; checkbox.disabled = true; }
        else checkbox.disabled = false;
        if (checkbox.checked) { items.push({ id: Number(option.value), quantity }); total += Number(option.dataset.price) * quantity; }
      });
      return { wheel, items, total };
    }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100); }
    update() {
      const { wheel, total } = this.selection();
      this.querySelector('[data-wheel-title]').textContent = wheel?.title || '';
      this.querySelector('[data-wheel-price]').textContent = this.money(wheel?.price || 0);
      this.querySelector('[data-total]').textContent = this.money(total);
      this.button.disabled = this.busy || !wheel?.available;
      this.button.textContent = this.busy ? this.data.strings.adding : this.data.strings.add;
    }
    async addItems() {
      if (this.busy) return;
      const { wheel, items } = this.selection();
      if (!wheel?.available) { this.status.textContent = this.data.strings.unavailable; return; }
      this.busy = true; this.status.textContent = ''; this.querySelector('.ecb-cart').hidden = true; this.update();
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Cart rejected selection');
        this.status.textContent = this.data.strings.success;
        this.querySelector('.ecb-cart').hidden = false;
        window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      } catch (error) {
        this.status.textContent = this.data.strings.error;
        this.querySelector('.ecb-cart').hidden = false;
      } finally { this.busy = false; this.update(); }
    }
  }
  customElements.define('eudm-carismo-bundle', CarismoBundle);
})();
